module.exports = __webpack_public_path__ + "img/1440.313a8b17.jpg";